module.exports = __webpack_public_path__ + "static/media/nauka-programowania-dla-dzieci-inf2-3.66d80aa8.png";